// Import React Library
import React from 'react';

// Import Components
import Footer from '../components/Footer';
import Banner from '../components/Banner';
import WhatsappButton from '../components/WhatsappButton';
import WorkWithUsComponent from '../components/WorkWithUsComponent';
import NavbarProducts from '../components/NavbarProducts';

// Constructions Component
const Constructions = () => {
    return (
        <>
           {/* 🔹 Navbar fijo arriba */}
            <div style={{ position: "fixed", top: 0, left: 0, right: 0, zIndex: 50 }}>
                <NavbarProducts />
            </div>

            <Banner />

            <main 
                style={{ paddingTop: "80px", minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", }}
            >
                <WhatsappButton />
                <WorkWithUsComponent />
            </main>

            {/* Footer al final */}
            <Footer />
        </>
    );
};

// Export Constructions Component
export default Constructions;